<template>
  <div>
    <section class="section">
      <div class="container">
        <div class="columns">
          <div class="column is-6">
            <h1 class="heading is-size-4">Settings</h1>
            <br />
            <div class="field">
              <b-checkbox v-model="settings.inactivityNotificationsOn">
                Inactivity Notifications
              </b-checkbox>
              <p class="is-size-7">
                SpeakyReads will send you an email reminder if you don't
                practice for a couple of days in a row. It won't be more than ~5
                emails in the first month of inactivity. After that, we will
                assume you have given up.
              </p>
            </div>
            <br />
            <b-button
              type="is-primary"
              @click="saveSettings"
              :loading="savingSettings"
            >
              Save Settings
            </b-button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import dataService from "../services/dataService";

export default {
  name: "Settings",
  data() {
    return {
      settings: undefined,
      savingSettings: false,
      loadingPortal: false,
      portalError: false
    };
  },
  methods: {
    async saveSettings() {
      this.savingSettings = true;
      await dataService.saveSettings(this.settings);
      this.savingSettings = false;
    }
  },
  async created() {
    if (this.settings === undefined) {
      this.settings = await dataService.getSettings();
    }
  }
};
</script>

<style lang="scss" scoped></style>
